import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Trash2 } from "lucide-react";

interface ButtonData {
  text: string;
  url: string;
  variant: "primary" | "outline";
}

interface ButtonEditorProps {
  buttons: ButtonData[];
  onChange: (buttons: ButtonData[]) => void;
}

export function ButtonEditor({ buttons, onChange }: ButtonEditorProps) {
  const addButton = () => {
    if (buttons.length >= 2) return;
    onChange([...buttons, { text: "", url: "", variant: "primary" }]);
  };

  const removeButton = (index: number) => {
    onChange(buttons.filter((_, i) => i !== index));
  };

  const updateButton = (index: number, field: keyof ButtonData, value: string) => {
    const updated = buttons.map((btn, i) =>
      i === index ? { ...btn, [field]: value } : btn
    );
    onChange(updated);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium">Botões CTA</label>
        {buttons.length < 2 && (
          <Button type="button" variant="outline" size="sm" onClick={addButton}>
            <Plus className="h-4 w-4 mr-1" /> Adicionar
          </Button>
        )}
      </div>
      {buttons.map((btn, i) => (
        <div key={i} className="flex flex-col sm:flex-row gap-2 p-3 border rounded-lg bg-muted/30">
          <Input
            placeholder="Texto do botão"
            value={btn.text}
            onChange={e => updateButton(i, "text", e.target.value)}
            className="flex-1"
          />
          <Input
            placeholder="URL (https://...)"
            value={btn.url}
            onChange={e => updateButton(i, "url", e.target.value)}
            className="flex-1"
          />
          <Select value={btn.variant} onValueChange={v => updateButton(i, "variant", v)}>
            <SelectTrigger className="w-32">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="primary">Primário</SelectItem>
              <SelectItem value="outline">Outline</SelectItem>
            </SelectContent>
          </Select>
          <Button type="button" variant="ghost" size="icon" onClick={() => removeButton(i)}>
            <Trash2 className="h-4 w-4 text-destructive" />
          </Button>
        </div>
      ))}
    </div>
  );
}
